/* ============================================================
   Apotheca PDP Redesign layer (JS) — runs only on .pdp-redesign
   Builds the sticky section nav + sticky buy bar, converts the
   deep content into accordions, supersedes the legacy mobile
   accordion, and removes redundant sections. Works across
   product types (supplement / bioregulator / lab) by reading
   whatever sections are actually present, in DOM order. Pure
   progressive enhancement: if it fails, the standard PDP works.
   ============================================================ */
(function () {
  // Sections that become collapsed accordions, with teaser text.
  var ACC_TEASERS = {
    'gabriel-rec': 'signals verified',
    'mechanism': 'how it works',
    'sema-candidacy': 'best fit & cautions',
    'sema-timeline': 'typical timeline',
    'dosing-protocol': 'therapeutic & microdose',
    'purity': 'COA & testing',
    'sema-side-effects': 'common & rare',
    'sema-comparison': 'forms compared',
    'sema-stacking': 'stack for synergy',
    'sema-clinical-dose': 'dose verified',
    'sema-research-studies': 'clinical citations',
    'related-peptides': 'related formulations',
    'clinical-review': 'how to order'
  };
  // Friendly nav labels per section (data-section key, or special class/heading).
  var NAV_LABELS = {
    'mechanism': 'How It Works',
    'how-to-take': 'How to Take',
    'sema-candidacy': "Who It's For",
    'sema-timeline': 'What to Expect',
    'dosing-protocol': 'Dosing',
    'purity': 'Purity',
    'sema-side-effects': 'Side Effects',
    'sema-comparison': 'Compare',
    'sema-stacking': 'Pairs With',
    'sema-clinical-dose': 'Clinical Dose',
    'sema-research-studies': 'Research',
    'related-peptides': 'Related',
    'clinical-review': 'How to Order',
    'sema-faq': 'FAQ'
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    if (!document.documentElement.classList.contains('pdp-redesign')) return;
    setTimeout(init, 0); // run after the section's own init binds its handlers

    function init() {
      var belowFold = document.querySelector('.below-fold');
      if (!belowFold) return;

      // Strip the legacy mobile-accordion behavior so it can't fight ours.
      ['[data-section="how-to-take"]', '[data-section="sema-candidacy"]', '[data-section="sema-timeline"]']
        .forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (card) {
            card.classList.remove('section-collapsed', 'section-collapsible');
            var h = card.querySelector('.section-header');
            if (h) h.parentNode.replaceChild(h.cloneNode(true), h);
          });
        });

      // Accordions for every deep section that's present (by data-section).
      Object.keys(ACC_TEASERS).forEach(function (key) {
        var sel = key === 'gabriel-rec' ? '.gabriel-rec' : '[data-section="' + key + '"]';
        document.querySelectorAll(sel).forEach(function (card) { makeAccordion(card, ACC_TEASERS[key]); });
      });

      // Sections rendered after .below-fold (no data-section): clean up by heading.
      document.querySelectorAll('.section-card').forEach(function (card) {
        if (card.classList.contains('rd-acc')) return;
        var h = card.querySelector(':scope > .section-header > h2, :scope > .section-header > h3, :scope > h2, :scope > h3');
        if (!h) return;
        var t = h.textContent;
        if (/research\s+behind/i.test(t) || /practitioner\s+insight/i.test(t) || /who\s+this\s+is\s+for/i.test(t)) {
          card.classList.add('rd-hide');                          // redundant / empty / placeholder
        } else if (/compatibility/i.test(t)) {
          makeAccordion(card, 'good & avoid');
        } else if (/research\s+evidence/i.test(t)) {
          makeAccordion(card, 'clinical citations');
        }
      });

      // Relabel "About" → "Overview" + optional at-a-glance.
      var overview = document.querySelector('.product-description-section');
      if (overview) {
        var oh = overview.querySelector('.section-header h2, .section-header h3, h2, h3');
        if (oh) oh.textContent = 'Overview';
        injectAtAGlance(overview);
      }

      // ── Zone consolidation v2 (2026-08-19): document flow, not boxes.
      var isPeptidePage = !!document.querySelector('[data-section="mechanism"]');
      var overviewCard = document.querySelector('.product-description-section');
      var usageZone = null, learnZone = null;
      var comparisonCard = document.querySelector('[data-section="sema-comparison"]');
      var compareLink = document.querySelector('.pdp-compare-link');
      var stackingCard = document.querySelector('[data-section="sema-stacking"]');
      var recsWrap = document.getElementById('apoRecsWrap');
      if (!isPeptidePage) {
        // 1) Overview -> "About this product": kicker, no duplicate stat tiles.
        if (overviewCard) {
          overviewCard.classList.add('rd-about');
          var oh = overviewCard.querySelector('.section-header');
          if (oh) { var k = document.createElement('div'); k.className = 'rd-kicker'; k.textContent = 'About this product'; oh.parentNode.replaceChild(k, oh); }
          var ag = overviewCard.querySelector('.rd-ataglance');
          if (ag) ag.remove();
        }
        // 2) "Why Gabriel" -> horizontal checklist band under the description.
        var rec = document.querySelector('.gabriel-rec');
        if (overviewCard && rec && getComputedStyle(rec).display !== 'none') {
          rec.classList.remove('rd-acc', 'rd-collapsible', 'rd-open');
          var rh = rec.querySelector('.section-header');
          if (rh) { var k2 = document.createElement('div'); k2.className = 'rd-kicker'; k2.textContent = 'Why Gabriel recommends this'; rh.parentNode.replaceChild(k2, rh); }
          rec.classList.add('rd-rec-band');
          overviewCard.appendChild(rec);
        }
        // 3) Usage rows in one flat group.
        var usageCards = [];
        ['[data-section="how-to-take"]', '[data-section="sema-candidacy"]', '[data-section="sema-timeline"]'].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el && getComputedStyle(el).display !== 'none') usageCards.push(el);
        });
        document.querySelectorAll('.section-card').forEach(function (card) {
          var h = card.querySelector('h2, h3');
          if (h && /compatibility/i.test(h.textContent) && getComputedStyle(card).display !== 'none' && usageCards.indexOf(card) === -1) usageCards.push(card);
        });
        if (usageCards.length >= 2) {
          usageZone = document.createElement('div');
          usageZone.className = 'rd-zone-group rd-zone-usage';
          var kick = document.createElement('div');
          kick.className = 'rd-kicker rd-zone-kicker';
          kick.textContent = 'Using this product';
          usageZone.appendChild(kick);
          usageCards[0].parentNode.insertBefore(usageZone, usageCards[0]);
          usageCards.forEach(function (c) { usageZone.appendChild(c); c.classList.add('rd-zoned'); });
        }
        // 4) "Compare & learn" group: comparison accordion row + guide link row.
        if (comparisonCard || compareLink) {
          learnZone = document.createElement('div');
          learnZone.className = 'rd-zone-group rd-zone-learn';
          var lk = document.createElement('div');
          lk.className = 'rd-kicker rd-zone-kicker';
          lk.textContent = 'Compare & learn';
          learnZone.appendChild(lk);
          var anchorEl = comparisonCard || (usageZone ? usageZone.nextElementSibling : null);
          if (anchorEl && anchorEl.parentNode) anchorEl.parentNode.insertBefore(learnZone, anchorEl);
          else if (usageZone) usageZone.parentNode.insertBefore(learnZone, usageZone.nextSibling);
          if (comparisonCard) { learnZone.appendChild(comparisonCard); comparisonCard.classList.add('rd-zoned'); }
          if (compareLink) { compareLink.classList.add('rd-link-row'); learnZone.appendChild(compareLink); }
        }
        // 5) Curated "Frequently Taken Together": premium placement inside the product
        //    story (after Compare & learn, before FAQ), compact image cards.
        if (stackingCard) {
          stackingCard.classList.remove('rd-acc', 'rd-collapsible');
          stackingCard.classList.add('rd-open', 'rd-stack-in-pairs');
          var sh = stackingCard.querySelector('.section-header');
          if (sh) { var k3 = document.createElement('div'); k3.className = 'rd-kicker rd-zone-kicker'; k3.textContent = 'Frequently taken together'; sh.parentNode.replaceChild(k3, sh); }
          var host2 = learnZone || usageZone;
          if (host2 && host2.parentNode) host2.parentNode.insertBefore(stackingCard, host2.nextSibling);
          var fbt = document.getElementById('apoFbt');
          if (fbt) { fbt.dataset.suppressed = '1'; fbt.style.display = 'none'; }
        }
        // 6) Brand story folds into the About card as a quiet bottom row.
        var brandToggle = document.querySelector('.brand-story-toggle');
        if (brandToggle && overviewCard) {
          var brandCard = brandToggle.closest('.section-card');
          if (brandCard && brandCard !== overviewCard) {
            brandCard.classList.add('rd-brand-row');
            overviewCard.appendChild(brandCard);
          }
        }
        // 7) Compliance disclaimer belongs at the very end of the flow.
        var disc = document.querySelector('.pdp-ff-disclaimer');
        if (disc && recsWrap && recsWrap.parentNode) {
          recsWrap.parentNode.insertBefore(disc, recsWrap.nextSibling);
          disc.classList.add('rd-disc-bottom');
        }
      }

      var ingredientCard = document.querySelector('[data-section="product-label"]');
      if (ingredientCard && overviewCard) overviewCard.after(ingredientCard);

      // Build the sticky section nav from sections present, in DOM order.
      var cards = [].slice.call(document.querySelectorAll(
        '.below-fold > .section-card, .below-fold > [data-section], .shopify-section > .section-card'
      ));
      var reviews = document.querySelector('#reviewSources');
      if (reviews) { var rc = reviews.closest('.section-card') || reviews; if (cards.indexOf(rc) === -1) cards.push(rc); }
      // keep unique + DOM order
      cards = cards.filter(function (el, i) { return cards.indexOf(el) === i; })
                   .sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });

      var items = [], usedLabels = {};
      if (!isPeptidePage) {
        var reviewsEl = document.querySelector('#reviewSources');
        if (reviewsEl) reviewsEl = reviewsEl.closest('.section-card') || reviewsEl;
        var faqEl = document.querySelector('[data-section="sema-faq"]');
        if (!faqEl) {
          document.querySelectorAll('.section-card').forEach(function (card) {
            var h = card.querySelector('h2, h3');
            if (!faqEl && h && /frequently asked/i.test(h.textContent)) faqEl = card;
          });
        }
        var pairsEl = document.querySelector('[data-section="sema-stacking"]') || document.getElementById('apoRecsWrap');
        [
          { label: 'Overview', el: overviewCard },
          { label: 'Ingredients', el: document.querySelector('[data-section="product-label"]') },
          { label: 'How to Use', el: usageZone || document.querySelector('[data-section="how-to-take"]') },
          { label: 'Compare', el: learnZone || comparisonCard || compareLink },
          { label: 'Pairs With', el: pairsEl },
          { label: 'FAQ', el: faqEl },
          { label: 'Reviews', el: reviewsEl }
        ].forEach(function (z) {
          if (!z.el || usedLabels[z.label]) return;
          // "Pairs With" targets the recs wrap, which reveals itself after an async
          // fetch; include it by existence rather than current visibility.
          if (z.label !== 'Pairs With' && getComputedStyle(z.el).display === 'none') return;
          usedLabels[z.label] = 1;
          items.push(z);
        });
      } else {
        cards.forEach(function (el) {
          if (getComputedStyle(el).display === 'none' || el.classList.contains('rd-hide')) return;
          var label = labelFor(el);
          if (!label || usedLabels[label]) return;
          usedLabels[label] = 1;
          items.push({ label: label, el: el });
        });
      }

      var links = [];
      if (items.length > 1) {
        var nav = document.createElement('nav');
        nav.className = 'rd-secnav';
        var inner = document.createElement('div');
        inner.className = 'rd-secnav-inner';
        items.forEach(function (it, i) {
          if (!it.el.id) it.el.id = 'rd-sec-' + i;
          var a = document.createElement('a');
          a.href = '#' + it.el.id;
          a.textContent = it.label;
          a.addEventListener('click', function (e) {
            e.preventDefault();
            if (it.el.classList.contains('rd-acc')) it.el.classList.add('rd-open');
            window.scrollTo({ top: it.el.getBoundingClientRect().top + window.scrollY - 56, behavior: 'smooth' });
          });
          inner.appendChild(a);
          links.push(a);
        });
        nav.appendChild(inner);
        belowFold.insertBefore(nav, belowFold.firstChild);
      }

      // Scrollspy
      if (links.length) {
        var spy = function () {
          var y = window.scrollY + 80, idx = 0;
          items.forEach(function (it, i) { if (it.el.getBoundingClientRect().top + window.scrollY <= y) idx = i; });
          links.forEach(function (a, i) { a.classList.toggle('active', i === idx); });
        };
        window.addEventListener('scroll', spy, { passive: true });
        spy();
      }

      buildBuyBar();
    }

    function labelFor(el) {
      var ds = el.getAttribute('data-section');
      if (ds && NAV_LABELS[ds]) return NAV_LABELS[ds];
      if (el.classList.contains('product-description-section')) return 'Overview';
      if (el.classList.contains('gabriel-rec')) return 'Why Gabriel';
      var h = el.querySelector(':scope > .section-header > h2, :scope > .section-header > h3, :scope > h2, :scope > h3');
      var t = h ? h.textContent : '';
      if (/real reviews|reviews\b/i.test(t)) return 'Reviews';
      if (/compatibility/i.test(t)) return 'Compatibility';
      if (/research/i.test(t)) return 'Research';
      return null;
    }

    function makeAccordion(card, teaser) {
      if (card.classList.contains('rd-acc')) return;
      var header = card.querySelector('.section-header');
      if (!header) return;
      var fresh = header.cloneNode(true);
      header.parentNode.replaceChild(fresh, header);
      header = fresh;
      card.classList.add('rd-acc', 'rd-collapsible');
      card.classList.remove('rd-open');
      var h = header.querySelector('h2, h3');
      if (teaser && h && !header.querySelector('.rd-teaser')) {
        var t = document.createElement('span');
        t.className = 'rd-teaser';
        t.textContent = teaser;
        h.insertAdjacentElement('afterend', t);
      }
      header.addEventListener('click', function () { card.classList.toggle('rd-open'); });
    }

    function injectAtAGlance(about) {
      if (about.querySelector('.rd-ataglance')) return;
      var strip = document.querySelector('.product-spec-strip');
      if (!strip) return;
      var parts = strip.textContent.split('·').map(function (s) { return s.trim(); }).filter(Boolean);
      if (parts.length < 2) return;
      var labels = ['Form', 'Size', 'Servings', 'Per serving'];
      var grid = document.createElement('div');
      grid.className = 'rd-ataglance';
      parts.slice(0, 4).forEach(function (val, i) {
        var cell = document.createElement('div');
        cell.className = 'rd-ag';
        cell.innerHTML = '<div class="k"></div><div class="v"></div>';
        cell.querySelector('.k').textContent = labels[i] || '';
        cell.querySelector('.v').textContent = val;
        grid.appendChild(cell);
      });
      var hdr = about.querySelector('.section-header');
      if (hdr) hdr.insertAdjacentElement('afterend', grid); else about.appendChild(grid);
    }

    function buildBuyBar() {
      if (document.querySelector('.rd-buybar')) return;
      var realAtc = document.querySelector('.add-cart-btn, .prac-gate-btn, button[type="submit"][class*="cart"]');
      var purchase = document.querySelector('.purchase-section');
      if (!realAtc || !purchase) return;

      var title = (document.querySelector('.product-title-main') || {}).textContent || 'Add to Cart';
      var vendor = (document.querySelector('.product-brand-link') || {}).textContent || '';
      var img = document.querySelector('.product-gallery img');
      var imgSrc = img ? (img.currentSrc || img.src) : '';
      var priceEl = purchase.querySelector('.price, [class*="price"]:not([class*="per"])');
      var price = priceEl ? priceEl.textContent.trim() : ((realAtc.textContent.match(/\$[\d.,]+/) || [''])[0]);
      var rating = (document.querySelector('.trust-bar-rating') || {}).textContent || '';
      var score = (document.querySelector('.trust-bar-num') || {}).textContent || '';
      var btnLabel = (realAtc.textContent || 'Add to Cart').replace(/\s*[—-]\s*\$.*$/, '').trim() || 'Add to Cart';

      var bar = document.createElement('div');
      bar.className = 'rd-buybar';
      bar.innerHTML =
        '<div class="rd-buybar-inner">' +
          (imgSrc ? '<img class="rd-bb-img" src="' + imgSrc + '" alt="">' : '') +
          '<div class="rd-bb-name">' + esc(title) + (vendor ? '<small>' + esc(vendor) + '</small>' : '') + '</div>' +
          (rating ? '<span class="rd-bb-sc">★ ' + esc(rating) + (score ? ' · Quality & Trust ' + esc(score) : '') + '</span>' : '') +
          '<span class="rd-bb-price">' + esc(price) + '</span>' +
          '<button class="rd-bb-btn" type="button">' + esc(btnLabel) + '</button>' +
        '</div>';
      document.body.appendChild(bar);
      bar.querySelector('.rd-bb-btn').addEventListener('click', function () { realAtc.click(); });

      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(purchase);
    }

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
  });
})();
